export const API_AFTER_LANGUAGE_CHANGE_EVENT_NAME = 'afterLanguageChange';
